var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNumberplateDecoration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 15.4h1.4v4c0 .4.1.8.2 1 .2.4.5.5 1.1.5.5 0 .9-.2 1.1-.5.1-.2.2-.5.2-1v-4h1.4v4c0 .7-.1 1.2-.3 1.6-.4.7-1.1 1-2.2 1s-1.9-.3-2.3-1c-.5-.4-.6-1-.6-1.7v-3.9zm6.4 0h1.3V18l2.5-2.7h1.7L10.3 18l2.8 3.8h-1.7l-2-2.8-.6.7v2.2H7.4v-6.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 3h14v7H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#C81626",
    d: "M14 5.8H7.7V3H6.3v2.8H0v1.4h6.3V10h1.4V7.2H14"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#C81626",
    d: "M9.3 7.7h1L14 9.5v.5M4.7 5.3h-1L0 3.5V3l4.7 2.3zm0 2.4h1L1 10H0l4.7-2.3zm4.6-2.4h-1L13 3h1L9.3 5.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B097F",
    d: "M0 7.7v1.6l3.1-1.6m10.9 0v1.6l-3.1-1.6H14zM0 5.3V3.8l3.1 1.6H0zm14 0V3.8l-3.1 1.6H14zM5.8 10V7.9L1.6 10h4.2zm2.4 0V7.9l4.3 2.1H8.2zM5.8 3v2.1L1.6 3h4.2zm2.4 0v2.1L12.4 3H8.2z"
  })));
}

export default SvgNumberplateDecoration;